import React from 'react'
import {
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './Styles'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import SaveIcon from '@material-ui/icons/Save'
import AddNewDialog from '../../Dialog/AddNewDialog'
import TemplateSave from '../../../FormFields/EntityAddForm/TemplateSave'

const SaveInvoiceBtn = ({ disabled, handleSaveInvoiceEntity, savedTemplateData }) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const menuAnchorRef = React.useRef(null)

  const handleButtonMenuToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (menuAnchorRef?.current && menuAnchorRef?.current?.contains(event?.target)) {
      return
    }
    setOpen(false)
  }
  const [templateDialogOpen, setTemplateDialogOpen] = React.useState(false)
  const handleSaveTemplateDialog = (e) => {
    !!e?.preventDefault && e.preventDefault()
    !!e?.stopPropagation && e.stopPropagation()
    setTemplateDialogOpen(!templateDialogOpen)
    handleClose(e)
  }
  return (
    <>
      <ButtonGroup color="secondary" ref={menuAnchorRef} aria-label="menu button" disabled={disabled}
                   className={classes.saveInvoiceBtnWrapper}>

        <Button className={'cancel'} variant={'contained'} size={'large'} color={'primary'}
                endIcon={<SaveIcon className={'save'}/>}
                onClick={(e) => handleSaveInvoiceEntity(e, 'draft')}>
          <FormattedMessage id='invoiceSteps.button.saveDraft'/>
        </Button>

        <Button size={'small'} variant={'contained'} color={'primary'} className={'btn-menu'}
                aria-controls={open ? 'actions-button-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-label="Select type of invoice saving"
                aria-haspopup="menu"
                onClick={handleButtonMenuToggle}
        >
          <ArrowDropDownIcon className={'save'}/>
        </Button>
      </ButtonGroup>
      <Popper open={open} className={classes.menuPopper} anchorEl={menuAnchorRef.current} role={undefined}
              transition
              disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'right top' : 'right bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="actions-button-menu">
                  <MenuItem onClick={handleSaveTemplateDialog}
                  >
                    <FormattedMessage id='invoiceSteps.button.saveTemplate'/>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      <AddNewDialog
        children={
          <Box p={3}>
            <TemplateSave
              onSubmit={(values, formikActions) => handleSaveInvoiceEntity(null, 'template', values, formikActions, handleSaveTemplateDialog)}
              currentData={savedTemplateData}
              cancelDialog={handleSaveTemplateDialog}/>
          </Box>
        }
        DialogTitle={<FormattedMessage id={'saveTemplate.dialog.Title'}/>}
        isDialogOpen={templateDialogOpen}
        cancelDialog={handleSaveTemplateDialog}/>
    </>
  )
}

export default SaveInvoiceBtn
